import {MinusOutlined, PlusOutlined} from '@ant-design/icons';
import {Checkbox, Col, Collapse, Input, Row, Skeleton, Tag} from 'antd';
import {Link, navigate} from 'gatsby';
import React, {useEffect, useState} from 'react';

import CollapseIcon from '~components/icons/collapse';
import Expand from '~components/icons/expand';
import {filterPriceTypes} from '~constants/product-list';
import {
  buildImageUrl,
  getTextColor,
  numberToCurrency,
  generateTreeList,
  handelRootTree,
  convertCategoryTreeData,
  getCategoryQuery,
} from '~utils/helper';
import CATEGORIES_PARENT from '~constants/categories';

import './styles.scss';

const {Panel} = Collapse;

const ChildCategory = ({parentCat, selectedCategories, handleCheckCategory, getParentCategoryUrl, childCategories}) => {
  return (
    <>
      <li className='category-item'>
        <Checkbox
          indeterminate={selectedCategories.findIndex(y => parentCat.id == y) > -1}
          onChange={() => handleCheckCategory(parentCat.id)}
          checked={false}
          style={{marginRight: '8px'}}
        />
        <Link to={getParentCategoryUrl(parentCat)}>Tất cả</Link>
      </li>
      {childCategories.map(childCat => (
        <li
          key={childCat.id}
          className={`category-item ${
            selectedCategories.findIndex(y => childCat.id == y) > -1 ? 'selected-category' : ''
          }`}
        >
          <Checkbox
            indeterminate={selectedCategories.findIndex(y => childCat.id == y) > -1}
            onChange={() => handleCheckCategory(childCat.id)}
            checked={false}
            style={{marginRight: '8px'}}
          />
          <span>{childCat.name}</span>
        </li>
      ))}
    </>
  );
};

const ParentCagegory = ({
  expandedParentIds,
  selectedCategories,
  parentCat,
  toggleParentExpand,
  getParentCategoryUrl,
  handleCheckCategory,
}) => {
  const isExpanded = expandedParentIds.findIndex(x => x == parentCat.id) > -1;
  const childCategories = parentCat.children || [];

  const renderChildCategories = childCate => {
    return (
      <>
        <li
          key={childCate.id}
          className={`child-category-item ${
            selectedCategories.findIndex(y => childCate.id == y) > -1 ? 'selected-category' : ''
          }`}
        >
          <Checkbox
            indeterminate={selectedCategories.findIndex(y => childCate.id == y) > -1}
            onChange={() => handleCheckCategory(childCate.id)}
            checked={false}
            style={{marginRight: '8px'}}
          />
          <span>{childCate.title}</span>
        </li>
        {childCate?.children?.map(subChild => {
          return renderChildCategories(subChild);
        })}
      </>
    );
  };

  return isExpanded ? (
    <li key={parentCat.id} className='parent-category'>
      <div className={selectedCategories.findIndex(y => parentCat.id == y) > -1 ? 'selected-category' : ''}>
        <Checkbox
          indeterminate={selectedCategories.findIndex(y => parentCat.id == y) > -1}
          onChange={() => handleCheckCategory(parentCat.id)}
          checked={false}
          style={{marginRight: '8px'}}
        />
        <span onClick={() => toggleParentExpand(parentCat.id)} style={{cursor: 'pointer'}}>
          {parentCat.title}
        </span>
        {childCategories.length > 0 && (
          <span style={{marginLeft: '12px'}} onClick={() => toggleParentExpand(parentCat.id)}>
            <CollapseIcon />
          </span>
        )}
      </div>
      {childCategories.length > 0 && (
        <ul className='child-category'>
          <li className='child-category-item'>
            <Checkbox
              indeterminate={selectedCategories.findIndex(y => parentCat.id == y) > -1}
              onChange={() => handleCheckCategory(parentCat.id)}
              checked={false}
              style={{marginRight: '8px'}}
            />
            <Link to={getCategoryQuery(parentCat)}>Tất cả</Link>
          </li>
          {childCategories.map(childCat => renderChildCategories(childCat))}
        </ul>
      )}
    </li>
  ) : (
    <li
      key={parentCat.id}
      className={`category-item ${
        selectedCategories.findIndex(y => parentCat.id == y) > -1 ? 'selected-category' : ''
      }`}
    >
      <Checkbox
        indeterminate={selectedCategories.findIndex(y => parentCat.id == y) > -1}
        onChange={() => handleCheckCategory(parentCat.id)}
        checked={false}
        style={{marginRight: '8px'}}
      />
      <span onClick={() => toggleParentExpand(parentCat.id)} style={{cursor: 'pointer'}}>
        {parentCat.title}
      </span>
      {parentCat?.children?.length > 0 && (
        <span style={{marginLeft: '12px'}} onClick={() => toggleParentExpand(parentCat.id)}>
          <Expand />
        </span>
      )}
    </li>
  );
};

const CategoryMenu = ({menu, categoryId, searchParams, currentPath}) => {
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [priceRanges, setPriceRanges] = useState({rentalPrice: {}, salePrice: {}});
  const [attributes, setAttributes] = useState({});
  const [rate, setRate] = useState(0);
  const [category, setCategory] = useState([]);
  const [rootCategory, setRootCategory] = useState(null);
  const [activePanels, setActivePanels] = useState(['category']);
  const [expandedParentIds, setExpandedParentIds] = useState([]);
  const [isProvinceFilter, setIsProvinceFilter] = useState(false);
  const [clothes, setClothes] = useState([]);

  const removeFilter = () => {
    setSelectedBrands([]);
    setSelectedCategories([]);
    setPriceRanges({rentalPrice: {}, salePrice: {}});
    setAttributes({});
    setRate(0);
    setIsProvinceFilter(false);
    // Keep category panel open when removing filters
    setActivePanels(['category']);
    setExpandedParentIds([]);
  };

  const getParentCategoryByChildId = childId => {
    const childCategory = menu?.categories?.find(x => x.id == childId);
    const parentCategory = CATEGORIES_PARENT.filter(x => x.id == childId)[0];
    if ((childCategory && childCategory.parentId) || parentCategory) {
      return menu?.categories?.find(x => x?.id == childCategory?.parentId || x?.id == parentCategory?.id);
    }
    return null;
  };

  const getActivePanelsFromFilters = () => {
    const panels = [];

    // Always show category panel - users should always be able to select/deselect categories
    panels.push('category');

    // Show brand panel if brands are selected
    if (selectedBrands.length > 0) {
      panels.push('brand');
    }

    // Show attribute panels if attributes are selected
    if (Object.keys(attributes).length > 0) {
      Object.keys(attributes).forEach(attrId => {
        panels.push(attrId);
      });
    }

    // Show price panel if price ranges are set
    const hasPriceFilter = Object.values(priceRanges).some(range => range.minPrice || range.maxPrice);
    if (hasPriceFilter) {
      panels.push('price-ranges');
    }

    // Show rate panel if rate is selected
    if (rate > 0) {
      panels.push('rate');
    }

    // Show province panel if province filter is selected
    if (isProvinceFilter) {
      panels.push('province');
    }

    // Show category panel if categories are selected
    if (selectedCategories.length > 0) {
      // Also expand parent categories of selected child categories
      selectedCategories.forEach(catId => {
        const parentCat = getParentCategoryByChildId(catId);
        if (
          parentCat &&
          CATEGORIES_PARENT.filter(
            filter => parentCat.id === filter.id || parentCat.name.toLowerCase() === filter.name.toLowerCase()
          )
        ) {
          panels.push(`category-${parentCat.id}`);
        }
      });
    }

    return panels;
  };

  useEffect(() => {
    if (!menu) return;

    const rootParent = menu.categories.filter(x => !x.parentId);
    const remainData = menu.categories.filter(x => !!x.parentId);
    const treeData = generateTreeList(rootParent, remainData);
    const rootTree = handelRootTree(treeData);
    const fullCategory = convertCategoryTreeData(menu.categories, rootTree);
    setCategory(fullCategory);

    if (categoryId) {
      const selectedCategory = menu.categories.find(x => x.id == categoryId);
      if (selectedCategory) {
        if (!selectedCategory.parentId) {
          setRootCategory(selectedCategory);
        } else {
          const parentCategory = menu.categories.find(x => x.id == selectedCategory.parentId);
          setRootCategory(parentCategory);
        }
      }
    } else {
      setRootCategory(null);
    }

    const newSize = [];
    menu.attributes.forEach(att => {
      if (att.code === 'Size') {
        att.values.forEach(value => {
          const removeItem = ['0-0', '000', '64', '67', '85', '90'];
          if (!removeItem.includes(value.value)) {
            newSize.push(value);
          }
        });
        att.values = newSize;
      }
    });
  }, [menu, categoryId]);

  // Sync expanded parents based on current rootCategory (so initial load keeps current context open)
  useEffect(() => {
    if (rootCategory && rootCategory.id) {
      setExpandedParentIds([rootCategory.id]);
    } else {
      setExpandedParentIds([]);
    }
  }, [rootCategory]);

  useEffect(() => {
    if (!searchParams.toString()) {
      removeFilter();
      return;
    }
    const brands = searchParams.get('brands')?.split(',') || [];
    setSelectedBrands(brands);

    const categories = searchParams.get('categories')?.split(',') || [];
    setSelectedCategories(categories);

    const priceList = {rentalPrice: {}, salePrice: {}};
    filterPriceTypes.forEach(x => {
      const prices = searchParams.get(x.urlKey)?.split('-') || [];
      if (prices && prices.length === 2) priceList[x.key] = {minPrice: prices[0], maxPrice: prices[1]};
    });
    setPriceRanges({...priceList});

    setRate(searchParams.get('rate'));

    const attributeList = {};
    const attrParams = searchParams.get('attrs')?.split('-') || [];
    if (attrParams.length > 0) {
      attrParams.forEach(x => {
        const item = x.split(':');
        if (item.length === 2) {
          attributeList[item[0]] = item[1].split(',');
        }
      });
    }

    setAttributes(attributeList);

    // Sync province filter from URL
    const provinceFilter = searchParams.get('province') === 'true';
    setIsProvinceFilter(provinceFilter);
  }, [searchParams]);

  // Update active panels when filters change
  useEffect(() => {
    const panels = getActivePanelsFromFilters();
    setActivePanels(panels);
  }, [
    selectedBrands,
    selectedCategories,
    priceRanges,
    attributes,
    rate,
    categoryId,
    isProvinceFilter,
    menu?.categories,
  ]);

  const isPriceRangeValid = (minPrice, maxPrice) => parseInt(minPrice) <= parseInt(maxPrice);

  const handleApplyFilter = updatedAttributesParam => {
    // Ignore React synthetic event accidentally passed from onClick
    const isSyntheticEvent =
      updatedAttributesParam &&
      (updatedAttributesParam.nativeEvent ||
        updatedAttributesParam._reactName || // eslint-disable-line no-underscore-dangle
        updatedAttributesParam.target);

    // Không gán lại tham số — tạo biến mới
    const updatedAttributes = isSyntheticEvent ? undefined : updatedAttributesParam;

    // Use passed attributes or current state
    const attrsToUse = updatedAttributes !== undefined ? updatedAttributes : attributes;

    // 1. Brand filters
    if (selectedBrands.length > 0) {
      searchParams.set('brands', selectedBrands.join(','));
    } else {
      searchParams.delete('brands');
    }

    // 2. Category filters
    if (selectedCategories.length > 0) {
      searchParams.set('categories', selectedCategories.join(','));
    } else {
      searchParams.delete('categories');
    }

    // 3. Attribute filters
    if (Object.keys(attrsToUse).length > 0) {
      const attrsValue = Object.keys(attrsToUse)
        .map(x => {
          const raw = attrsToUse[x];
          // eslint-disable-next-line no-nested-ternary
          const values = Array.isArray(raw)
            ? raw
            : raw !== undefined && raw !== null
            ? String(raw)
                .split(',')
                .map(s => s.trim())
                .filter(Boolean)
            : [];
          return `${x}:${values.join(',')}`;
        })
        .join('-');

      searchParams.set('attrs', attrsValue);
    } else {
      searchParams.delete('attrs');
    }

    // 4. Price range filters
    filterPriceTypes.forEach(({key, urlKey}) => {
      const {minPrice, maxPrice} = priceRanges[key];
      if (minPrice && maxPrice && isPriceRangeValid(minPrice, maxPrice)) {
        searchParams.set(urlKey, `${minPrice}-${maxPrice}`);
      } else {
        searchParams.delete(urlKey);
      }
    });

    // 5. Rating filter
    if (rate > 0) {
      searchParams.set('rate', rate);
    } else {
      searchParams.delete('rate');
    }

    // 6. Province filter
    if (isProvinceFilter) {
      searchParams.set('province', 'true');
    } else {
      searchParams.delete('province');
    }

    // Navigate to filtered URL
    navigate(`${currentPath}?${searchParams.toString()}`);
  };

  const handleRemoveFilter = () => {
    removeFilter();
    navigate('/all-categories');
  };

  const handleCheckBrand = id => {
    selectedBrands.find(x => x == id)
      ? selectedBrands.splice(
          selectedBrands.findIndex(x => x == id),
          1
        )
      : selectedBrands.push(id);

    setSelectedBrands([...selectedBrands]);
  };

  const handleCheckCategory = id => {
    selectedCategories.find(x => x == id)
      ? selectedCategories.splice(
          selectedCategories.findIndex(x => x == id),
          1
        )
      : selectedCategories.push(id);

    setSelectedCategories([...selectedCategories]);
  };

  const toggleParentExpand = id => {
    const index = expandedParentIds.findIndex(x => x == id);
    if (index > -1) {
      const next = expandedParentIds.slice();
      next.splice(index, 1);
      setExpandedParentIds(next);
    } else {
      setExpandedParentIds([...expandedParentIds, id]);
    }
  };

  const onInputChange = (key, {target: {name, value}}) => {
    const newValue = value.replace(/\./g, '');
    const reg = /^\d*([\d]*)?$/;
    if (!newValue || reg.test(newValue)) {
      setPriceRanges({...priceRanges, [key]: {...priceRanges[key], [name]: newValue}});
    }
  };

  const handleSelectAttribute = (attrId, attrValueId) => {
    // Get current values for this attribute (don't mutate original)
    const currentValues = attributes[attrId] || [];
    const existedValueIdx = currentValues.findIndex(x => x == attrValueId);

    // Create new arrays without mutation
    let newValues;
    if (existedValueIdx > -1) {
      // Remove: create new array without the item
      newValues = currentValues.filter(x => x != attrValueId);
    } else {
      // Add: create new array with the new item
      newValues = [...currentValues, attrValueId];
    }

    // Create new attributes object
    const newAttributes = {...attributes};

    if (newValues.length === 0) {
      delete newAttributes[attrId];
    } else {
      newAttributes[attrId] = newValues;
    }

    setAttributes(newAttributes);
  };

  const handlePanelChange = keys => {
    setActivePanels(keys);
  };

  const getParentCategoryUrl = parentCat => {
    const params = new URLSearchParams();
    params.set('categories', parentCat.id.toString());

    if (selectedBrands.length > 0) {
      params.set('brands', selectedBrands.join(','));
    }

    if (Object.keys(attributes).length > 0) {
      params.set(
        'attrs',
        Object.keys(attributes)
          .map(x => {
            const raw = attributes[x];
            // eslint-disable-next-line no-nested-ternary
            const values = Array.isArray(raw)
              ? raw
              : raw !== undefined && raw !== null
              ? String(raw)
                  .split(',')
                  .map(s => s.trim())
                  .filter(Boolean)
              : [];
            return `${x}:${values.join(',')}`;
          })
          .join('-')
      );
    }

    filterPriceTypes.forEach(({key, urlKey}) => {
      if (
        priceRanges[key].minPrice &&
        priceRanges[key].maxPrice &&
        isPriceRangeValid(priceRanges[key].minPrice, priceRanges[key].maxPrice)
      ) {
        params.set(urlKey, `${priceRanges[key].minPrice}-${priceRanges[key].maxPrice}`);
      }
    });

    if (rate > 0) {
      params.set('rate', rate);
    }

    if (isProvinceFilter) {
      params.set('province', 'true');
    }

    const queryString = params.toString();
    return `/all-categories?${queryString}`;
  };

  if (!menu) return <Skeleton />;

  return (
    <div className='category-menu'>
      <div className='menu-title'>
        Bộ Lọc Sản Phẩm
        <div className='btn-filter'>
          <div className='apply-filter' onClick={() => handleApplyFilter()}>
            Áp dụng
          </div>
          <div className='remove-filter' onClick={handleRemoveFilter}>
            Bỏ chọn
          </div>
        </div>
      </div>
      <div>
        <Collapse
          activeKey={activePanels}
          onChange={handlePanelChange}
          expandIcon={({isActive}) => (isActive ? <MinusOutlined /> : <PlusOutlined />)}
          expandIconPosition='right'
          ghost
        >
          {category.map((parentCat, index) => (
            <Panel key={`category${index > 0 ? `-${parentCat.id}` : ''}`} header={parentCat?.title?.toUpperCase()}>
              <ul className='category-list'>
                <li className='category-item'>
                  <Link to={getCategoryQuery(parentCat)}>Tất Cả</Link>
                </li>
                {parentCat?.children?.map(subCate => {
                  return (
                    <ParentCagegory
                      selectedCategories={selectedCategories}
                      expandedParentIds={expandedParentIds}
                      parentCat={subCate}
                      toggleParentExpand={toggleParentExpand}
                      getParentCategoryUrl={getParentCategoryUrl}
                      handleCheckCategory={handleCheckCategory}
                    />
                  );
                })}
              </ul>
            </Panel>
          ))}
          <Panel key='brand' header='THƯƠNG HIỆU'>
            <ul className='collapse-list'>
              {menu.brands
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(x => (
                  <li key={x.id} className='collapse-item'>
                    <Checkbox
                      indeterminate={selectedBrands.findIndex(y => x.id == y) > -1}
                      onChange={e => handleCheckBrand(x.id)}
                      checked={false}
                    >
                      {x.name}
                    </Checkbox>
                  </li>
                ))}
            </ul>
          </Panel>
          {menu.attributes
            .filter(item => item.isEnabled)
            .sort((a, b) => (a.attributeOrder || 0) - (b.attributeOrder || 0))
            .map(
              item =>
                item.values && (
                  <Panel key={item.id} header={<span style={{textTransform: 'uppercase'}}>{item.name}</span>}>
                    <div className='collapse-list'>
                      {item.valueType === 'VALUE_TYPE_COLOR' ? (
                        <div className='color-grid'>
                          {item.values.map(y => (
                            <div
                              key={y.id}
                              className='color-item-wrapper'
                              onClick={() => handleSelectAttribute(item.id, y.id)}
                            >
                              {y.imageUrl ? (
                                <div
                                  className='color-image'
                                  style={{
                                    backgroundImage: `url(${buildImageUrl(y.imageUrl, '80x80')})`,
                                  }}
                                >
                                  <div
                                    className={`selected-item hover-item ${
                                      attributes[item.id]?.findIndex(item => item == y.id) > -1 ? 'display' : ''
                                    }`}
                                  />
                                </div>
                              ) : (
                                <Tag
                                  className='color-tag'
                                  style={{
                                    backgroundColor: typeof y === 'string' ? y : y.value,
                                    color: getTextColor(typeof y === 'string' ? y : y.value),
                                  }}
                                >
                                  <div
                                    className={`selected-item hover-item ${
                                      attributes[item.id]?.findIndex(item => item == y.id) > -1 ? 'display' : ''
                                    }`}
                                  />
                                </Tag>
                              )}
                              {typeof y === 'object' && y.name && <div className='color-name'>{y.name}</div>}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <ul className='collapse-list'>
                          {item.values
                            ?.slice()
                            .sort((a, b) => a.attributeValueOrder - b.attributeValueOrder)
                            .map(y => (
                              <li key={y.id} className='collapse-item'>
                                <Checkbox
                                  indeterminate={
                                    attributes[item.id] && attributes[item.id].findIndex(id => id == y.id) > -1
                                  }
                                  checked={false}
                                  onChange={() => handleSelectAttribute(item.id, y.id)}
                                >
                                  {typeof y === 'string' ? y : y.name || y.value}
                                </Checkbox>
                              </li>
                            ))}
                        </ul>
                      )}
                    </div>
                  </Panel>
                )
            )}
          <Panel key='price-ranges' header='KHOẢNG GIÁ'>
            <div className='collapse-list'>
              {filterPriceTypes.map(item => (
                <Row key={item.key}>
                  <label className='price-label' htmlFor='min-price'>
                    {item.title}
                  </label>
                  <Row className='price-input'>
                    <Col span={11}>
                      <Input
                        id='min-price'
                        value={numberToCurrency(priceRanges[item.key].minPrice)}
                        name='minPrice'
                        maxLength={11}
                        placeholder='Nhỏ nhất'
                        onChange={e => onInputChange(item.key, e)}
                      />
                    </Col>
                    <Col span={1} />
                    <Col span={11}>
                      <Input
                        id='max-price'
                        value={numberToCurrency(priceRanges[item.key].maxPrice)}
                        name='maxPrice'
                        maxLength={11}
                        placeholder='Lớn nhất'
                        onChange={e => onInputChange(item.key, e)}
                      />
                    </Col>
                  </Row>
                </Row>
              ))}
            </div>
          </Panel>
          <Panel key='province' header='KHU VỰC'>
            <div className='collapse-list'>
              <div className='collapse-item'>
                <Checkbox checked={isProvinceFilter} onChange={e => setIsProvinceFilter(e.target.checked)}>
                  Khách tỉnh
                </Checkbox>
              </div>
            </div>
          </Panel>
        </Collapse>
        <div className='btn-filter'>
          <div className='apply-filter' onClick={() => handleApplyFilter()}>
            Áp dụng
          </div>
          <div className='remove-filter' onClick={handleRemoveFilter}>
            Bỏ chọn
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryMenu;
